export class NucleusIdentityConfig {
  public authority: string = null;

  public clientId: string;

  public redirectUrl?: string;

  public httpInterceptorUrls?: string[] = [];

  public automaticLoginOnHttp401? : boolean = false;

}
